export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/hero.9ef38c77-4d6b19.png";